<template>
<div class="page_podstranka_blog page_podstranka_blog_item">


    <nav id="main_menu_phone_top" class="navbar navbar-expand-lg navbar-light">
      <NuxtLink :to="`/${langCode.code}-${activeCountry.code}`" class="navbar-brand mx-auto" title="hladamchatu.sk, ubytovací portál">
        <img :src="`/img/logo_${activeCountry.code}.svg`" :alt="$t('main-logo-title-alt')" class="img-fluid logo-brand" width="247" height="25">
      </NuxtLink>
    </nav>

    <Section :section="getPageDataSection(pageData, 'navbar')" :page="masterPage"></Section>

    <header>
      <div class="container">


        <div class="row">
          <div class="col-12 col-lg-8">

            <BackButton/>

            <figure class="shadow_3 aaa top-image" v-if="masterPage.hasImage()">
              <picture>
                <PartsSrcSetImage :image="masterPage.getTopImage()" :t_type="'cache'" :type="'webp'"/>
                <PartsSrcSetImage :image="masterPage.getTopImage()" :t_type="'cache'" :type="'jpeg'"/>
                <img :src="masterPage.getTopImage().getTyrionSrc('cache')" :alt="masterPage.title" class="img-cover" loading="lazy"
                     :width="masterPage.getTopImage().seoWidth('cache')" :height="masterPage.getTopImage().seoHeight('cache')"/>
              </picture>
            </figure>

            <div class="tags">
              <p v-for="tag in masterPage.tags" class="badge bg-light text-dark rounded-pill">{{tag.name}}</p>
            </div>

            <h1>
              {{ masterPage.getItemMeta('meta', 'title').setAlternative(`${masterPage.title}`).value }}
            </h1>

            <div class="page-info">
              <p class="author" v-if="masterPage.author && masterPage.author.name.length > 1"><span>{{ $t('Author' )}}:</span>{{masterPage.author.name}}</p>
              <p class="update"><span>{{ $t('update' )}}:</span>{{ formatTime(masterPage.updated_at, 'D.MM.YYYY') }}</p>
            </div>

            <div v-if="masterPage.intro && masterPage.intro.length > 3" v-html="masterPage.intro" class="fw-bold"></div>

          </div>
        </div>
      </div>
    </header>

    <main class="main">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8">
            <Holder :holder="getPageDataHolder(pageData, 'Obsah')" :page="masterPage"></Holder>
          </div>
        </div>
      </div>
      <Holder :holder="getPageDataHolder(pageData, 'Bottom')" :page="masterPage"></Holder>
    </main>

    <Section :section="getPageDataSection(pageData, 'footer')" :page="masterPage"></Section>

  </div>
</template>


<script setup lang="ts">
import {
  getPageDataHolder,
  getPageDataSection,
  obtainActiveLocale,
  obtainActiveWebCountry
} from "~/composables/master_page";
import BackButton from "~/components/web/parts/backButton.vue";
import {formatTime} from "../../../lib/functions";
import PageLink from "~/lib/PageLink";
import Holder from "~/components/Holder.vue";
import Section from "~/components/Section.vue";
import {useRuntimeConfig} from "#app";
import Page from "../../../lib/models/Page";

const pageLink = new PageLink(useRuntimeConfig().public.WEB_URL);
const props = defineProps({
  pageData: {}
});
const masterPage = (new Page()).fromObject(props.pageData.page) as Page;
const langCode = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();
</script>
